import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

import common_hr from '../src/translations/hr/hr.json'
import common_en from '../src/translations/en/en.json'

i18next.init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem("lang") || 'en',                              
  resources: {
      en: {
          common: common_en               
      },
      hr: {
          common: common_hr
      },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
